import { DynamicSchema } from './DynamicSchema'
import { definitions } from '../.types/DeletedEvent.schema.json'
import { DeletedEventSchema } from '../.types/DeletedEvent.schema'

export type { DeletedEventSchema } from '../.types/DeletedEvent.schema'

export const deletedEventSchema =
  DynamicSchema.new<DeletedEventSchema>({
    id: 'DeletedEventSchema',
    jsonSchema: definitions.DeletedEventSchema,
  })
